import { SportModel } from "../model";

const notSuitableSports = ["61", "62", "66", "70", "73", "75"];
export const SuitableSportFilter = (x:SportModel) => notSuitableSports.indexOf(x.id) === -1